import axios from 'axios'

const cmsApi = axios.create({
  baseURL: `//${import.meta.env.VITE_CDN_HOST}/maplestory/cms`,
})

const _convertObject = (data) => {
  if (typeof data !== 'object' || !data) return data
  Object.keys(data).forEach((key) => {
    const value = data[key]
    if (typeof value === 'object') {
      return _convertObject(value)
    }
    if (typeof value === 'string' && value.startsWith('/media')) {
      data[key] = `//${import.meta.env.VITE_CDN_HOST?.replace('pre.', '')}${value}`
    }
  })
}

cmsApi.interceptors.response.use((response) => {
  _convertObject(response.data)
  return response
})

const mscwApi = axios.create({
  baseURL: '/api/maplestory/v1',
})

export { cmsApi, mscwApi }
